import { Grid } from "@mui/material";
import React, { useMemo } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { notificationTypes } from "../../../variables/app";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormDatetimeTC from "../../../components/Forms/FormDatetimeTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function Algemeen() {
  const { menukaartVestigingId, vestigingId } = useFormContext();

  //Dropdown opties
  const notificationTypesOptions = useMemo(() => convertArrayToSelectOptions(notificationTypes), []);

  return (
    // <div style={{ width: "100%", height: "100%" }}>
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <FormSwitchTC name={"is_actief"} tDefault={"Actief"} tKey={"notifications.form.algemeen.label.is_actief"} />
          <FormSelectTC
            name={"type"}
            options={notificationTypesOptions}
            tDefault={"Type"}
            tKey={"notifications.form.algemeen.label.type"}
          />
          <FormTextTC name={"titel"} tDefault={"Titel"} tKey={"notifications.form.algemeen.label.titel"} />
          <FormTextTC name={"text"} rows={3} tDefault={"Text"} tKey={"notifications.form.algemeen.label.text"} />
          <FormDatetimeTC
            name={"startDate"}
            tDefault={"start datum/tijd"}
            tKey={"notifications.form.algemeen.label.startdatumtijd"}
          />
          <FormDatetimeTC
            name={"stopDate"}
            tDefault={"stop datum/tijd"}
            tKey={"notifications.form.algemeen.label.stopdatumtijd"}
          />
          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"productIds" + menukaartVestigingId}
            multiple={true}
            name={"productIds"}
            tDefault={"Alleen tonen bij deze producten"}
            tKey={"notifications.form.algemeen.label.producten"}
          />
          <FormAsyncTC
            async={{
              url:
                "core/tafels/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                vestigingId,
              searchField: "naam",
            }}
            key={"tafelIds" + vestigingId}
            multiple={true}
            name={"tafelIds"}
            tDefault={"Alleen tonen bij deze tafels"}
            tKey={"notifications.form.algemeen.label.tafels"}
          />
        </Grid>
      </CardBody>
    </Card>
    // </div>
  );
}

export default Algemeen;
